import React, { useContext, useState, useEffect } from 'react'
import { createCustomers } from '../../Utility/Api';
import { toast } from 'react-toastify';
import { WarehouseContext } from '../../Utility/UserContext';
import { validateEmail } from '../../Utility/function';

const CustomerAddModal = ({ showCustomer, setShowCustomer, onReqCustomer }) => {
    const { selectedWarehouse, showLoader, hideLoader, shopItem } = useContext(WarehouseContext);

    const [formdata, setFormdata] = useState({
        name: "",
        contact_email: "",
        phone: "",
        shop_id: shopItem?.shop_id || "0",
        // country: "",
        // branch: "",
        // status: "1",
        // additional_details: "",
        // TRN_no: '',
        // opening_balance: '',
        // CR_DR: ''
    });

    const handleChangeCustomer = (e) => {
        const { name, value } = e.target;
        setFormdata({
            ...formdata,
            [name]: value,
        });
    }

    const handleClearCustomer = () => {
        setFormdata({
            name: "",
            contact_email: "",
            phone: "",
            shop_id: shopItem?.shop_id || "0",
            // country: "",
            // branch: "",
            // status: "1",
            // additional_details: "",
            // TRN_no: '',
            // opening_balance: '',
            // CR_DR: ''
        });

        setTimeout(() => {
            setShowCustomer(false);
        }, 0);
    };

    const handleAddCustomer = async () => {
        showLoader()
        const validationErrors = {};

        if (!formdata.phone || formdata.phone.length < 8) {
            validationErrors.phone = !formdata.phone
                ? "Phone number is required."
                : "Phone number must be at least 8 digits long.";
        }

        for (const key in formdata) {
            if (key === 'additional_details' || key === 'status' || key === 'country' || key === 'TRN_no' || key === 'branch' || key === 'opening_balance' || key === 'CR_DR' || key === 'contact_email') {
                continue;
            }
            if (!formdata[key]) {
                validationErrors[key] = `${key.replace(/_/g, " ")} is required.`;
            }
        }

        // if (!validateEmail(formdata.contact_email)) {
        //     validationErrors.contact_email = "Invalid email address";
        // }

        if (Object.keys(validationErrors).length > 0) {
            hideLoader()
            toast.error(validationErrors[Object.keys(validationErrors)[0]])
            console.log(validationErrors);
            return;
        }

        console.log("Payload being sent:", formdata);

        try {
            await createCustomers(formdata);
            hideLoader()
            toast.success("Customers Added successfully");
            handleClearCustomer();
            onReqCustomer();
            setShowCustomer(false)
        } catch (error) {
            console.error("Error  data:", error.response?.data.message);
            hideLoader();
            toast.error(error.response?.data.message)
        }
    };
    return (
        <div
            className={`modal fade ${showCustomer ? "show" : ""}`}
            tabIndex={-1}
            role="dialog"
            style={{ display: showCustomer ? "block" : "none" }}
            aria-hidden={!showCustomer}
        >
            <div className="modal-dialog modal-md" role="document">
                <div className="modal-content">
                    <div className="container mx-auto p-0 grid grid-cols-1 lg:grid-cols-4 gap-6">
                        <div className="lg:col-span-3 bg-white shadow-lg rounded-xl p-8">
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                {/* Left Side Inputs */}
                                <label className="text-black font-18 mt-4 font-weight-2 w-50 mx-4">{"Add Customer"}</label>
                                <div className='row  p-4 pt-2'>
                                    <div className="space-y-5 col-12">
                                        <div key={"name"} className="grid grid-cols-3 items-center gap-1 d-flex flex-column">
                                            <label className="text-sm font-semibold text-gray-700 w-50 mt-2">{"Customer Name"}</label>
                                            <input
                                                type={"text"}
                                                name={"name"}
                                                value={formdata.name}
                                                onChange={handleChangeCustomer}
                                                placeholder={"Enter Name"}
                                                style={{ width: "90%" }}
                                                className="col-span-2 p-2 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-blue-300 focus:outline-none"
                                            />
                                        </div>
                                        <div key={"contact_email"} className="grid grid-cols-3 items-center gap-1 d-flex flex-column">
                                            <label className="text-sm font-semibold text-gray-700 w-25 mt-2">{"Email"}</label>
                                            <input
                                                type={"text"}
                                                name={"contact_email"}
                                                value={formdata.contact_email}
                                                onChange={handleChangeCustomer}
                                                placeholder={"Enter Email"}
                                                style={{ width: "90%" }}
                                                className="col-span-2 p-2 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-blue-300 focus:outline-none"
                                            />
                                        </div>
                                        <div key={"phone"} className="grid grid-cols-3 items-center gap-1 d-flex flex-column">
                                            <label className="text-sm font-semibold text-gray-700 w-25 mt-2">{"Phone"}</label>
                                            <input
                                                type={"number"}
                                                name={"phone"}
                                                value={formdata.phone}
                                                onChange={handleChangeCustomer}
                                                placeholder={"Enter Phone"}
                                                style={{ width: "90%" }}
                                                className="col-span-2 p-2 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-blue-300 focus:outline-none"
                                            />
                                        </div>
                                        {/* <div key={"country"} className="grid grid-cols-3 items-center gap-1 d-flex flex-column">
                                            <label className="text-sm font-semibold text-gray-700 w-25 mt-2">{"Country"}</label>
                                            <input
                                                type={"text"}
                                                name={"country"}
                                                value={formdata.country}
                                                onChange={handleChangeCustomer}
                                                placeholder={"Enter Country"}
                                                style={{ width: "90%" }}
                                                className="col-span-2 p-2 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-blue-300 focus:outline-none"
                                            />
                                        </div> */}
                                    </div>

                                    {/* <div className="space-y-5 col-6">
                                        <div key={"TRN_no"} className="grid grid-cols-3 items-center gap-1 d-flex flex-column">
                                            <label className="text-sm font-semibold text-gray-700 w-25 mt-2">{"TRN.no"}</label>
                                            <input
                                                type={"text"}
                                                name={"TRN_no"}
                                                value={formdata.TRN_no}
                                                onChange={handleChangeCustomer}
                                                placeholder={"Enter TRN.no"}
                                                style={{ width: "90%" }}
                                                className="col-span-2 p-2 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-blue-300 focus:outline-none"
                                            />
                                        </div>

                                        <div key={"branch"} className="grid grid-cols-3 items-center gap-1 d-flex flex-column">
                                            <label className="text-sm font-semibold text-gray-700 w-25 mt-2">{"Branch"}</label>
                                            <input
                                                type={"text"}
                                                name={"branch"}
                                                value={formdata.branch}
                                                onChange={handleChangeCustomer}
                                                placeholder={"Enter Branch"}
                                                style={{ width: "90%" }}
                                                className="col-span-2 p-2 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-blue-300 focus:outline-none"
                                            />
                                        </div>

                                        <div key={"opening_balance"} className="grid grid-cols-3 items-center gap-1 d-flex flex-column">
                                            <label className="text-sm font-semibold text-gray-700 w-25 mt-2">{"Balance"}</label>
                                            <input
                                                type="number"
                                                name={"opening_balance"}
                                                placeholder={"Enter Balance"}
                                                style={{ width: "90%" }}
                                                value={formdata.opening_balance}
                                                onChange={handleChangeCustomer}
                                                className="col-span-2 p-2 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-blue-300 focus:outline-none"
                                            />
                                        </div>

                                        <div key={"CR_DR"} className="grid grid-cols-3 items-center gap-1 d-flex flex-column">
                                            <label className="text-sm font-semibold text-gray-700 w-25 mt-2">{"CR/DR"}</label>
                                            <select
                                                name="CR_DR"
                                                style={{ width: "90%" }}
                                                value={formdata.CR_DR}
                                                onChange={handleChangeCustomer}
                                                className="col-span-2 p-2 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-blue-300 focus:outline-none"
                                            >
                                                <option value="">Select CR/DR</option>
                                                <option value="0">CR</option>
                                                <option value="1">DR</option>
                                            </select>
                                        </div>
                                    </div> */}
                                </div>

                                {/* Right Side Inputs */}
                                {/* <div className="space-y-5 ps-4 pe-5 pb-2 me-3">
                                    <div className="grid grid-cols-3 items-center gap-2 d-flex flex-column">
                                        <label className="text-sm font-semibold text-gray-700">Additional Details</label>
                                        <textarea
                                            name="additional_details"
                                            placeholder="Give some additional details"
                                            value={formdata.additional_details}
                                            onChange={handleChangeCustomer}
                                            className="col-span-2 w-full p-2 border border-gray-300 rounded-md text-sm focus:ring-2 focus:ring-blue-300 focus:outline-none min-h-[80px]"
                                        />
                                    </div>
                                </div> */}

                                {/* Action Buttons */}
                                <div className="flex flex-col items-center gap-4 p-3">
                                    <button
                                        onClick={() => { handleAddCustomer() }}
                                        className="w-full mx-2 btn btn-primary bg-blue-600 text-white px-4 py-2 rounded-lg text-sm font-semibold shadow-md hover:bg-blue-700 transition">
                                        Save
                                    </button>
                                    <button
                                        onClick={() => handleClearCustomer()}
                                        className="w-full mx-2 btn btn-secondary bg-gray-500 text-white px-4 py-2 rounded-lg text-sm font-semibold shadow-md hover:bg-gray-600 transition">
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CustomerAddModal